import { StyledSocialProof } from './SocialProof.styles'

export type SocialProofProps = {
  text?: string
  visible?: boolean
}

export const SocialProof = ({ text, visible = true }: SocialProofProps) => {
  if (!visible || !text) return null

  return (
    <StyledSocialProof>
      <p>{text}</p>
    </StyledSocialProof>
  )
}
